import logo from '@shared/assets/images/logo.png'
import styles from './Logo.module.scss'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
export const Logo = ({ variant,className }) => {
  const handleLinkClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  return (
    <Link to='/' onClick={handleLinkClick} className={className}>
      <div className={classNames(
        styles.container, 
        variant === 'footer' && styles.footer)}>
        <img src={logo} alt='logo' />
      </div>
    </Link>
  )
}
